import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useInView } from 'react-intersection-observer';

function ContactForm() {
  const { register, handleSubmit, formState: { errors }, reset } = useForm();
  const [submitted, setSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const { ref: formRef, inView: formInView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });
  const { ref: mapRef, inView: mapInView } = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    try {
      const response = await fetch('https://formspree.io/f/xanndlej', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      setSubmitted(true);
      reset(); // Form fields clear karne ke liye
      
      // 5 seconds baad success message hide kar dega
      setTimeout(() => setSubmitted(false), 5000); 
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div id="ultra-premium-contact">
      <style>
        {`
          #ultra-premium-contact {
            --brand-pink: #ec1c74;
            --brand-blue: #00a8e8;
            --bg-color: #fbfcfd;
            --glass-bg: rgba(255, 255, 255, 0.7);
            --glass-border: rgba(255, 255, 255, 0.9);
            --input-bg: rgba(255, 255, 255, 0.9);
            --text-dark: #1d1d1f;
            --text-muted: #6e6e73;
            --gradient-accent: linear-gradient(135deg, var(--brand-blue), var(--brand-pink));
            
            font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
            background: radial-gradient(circle at top left, rgba(0, 168, 232, 0.05), transparent 40%),
                        radial-gradient(circle at bottom right, rgba(236, 28, 116, 0.05), transparent 40%);
            background-color: var(--bg-color);
            padding: 6rem 2rem;
            display: flex;
            justify-content: center;
          }

          #ultra-premium-contact * {
            box-sizing: border-box;
          }

          #ultra-premium-contact .contact-wrapper {
            max-width: 1200px;
            width: 100%;
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 3rem;
            align-items: stretch;
          }

          /* Map Container Styling */
          #ultra-premium-contact .map-container {
            background: var(--glass-bg);
            border-radius: 32px;
            overflow: hidden;
            box-shadow: 0 20px 40px rgba(0, 0, 0, 0.04);
            border: 1px solid var(--glass-border);
            opacity: 0;
            transform: translateX(-40px);
            transition: all 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
            position: relative;
            min-height: 400px;
          }

          #ultra-premium-contact .map-container.animate {
            opacity: 1;
            transform: translateX(0);
          }

          #ultra-premium-contact .map-container iframe {
            border: none;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
          }

          /* Form Container Styling */
          #ultra-premium-contact .form-container {
            background: var(--glass-bg);
            backdrop-filter: blur(24px);
            -webkit-backdrop-filter: blur(24px);
            border-radius: 32px;
            padding: 3.5rem;
            box-shadow: 0 20px 50px rgba(0, 0, 0, 0.05), inset 0 1px 0 rgba(255, 255, 255, 1);
            border: 1px solid var(--glass-border);
            opacity: 0;
            transform: translateX(40px);
            transition: all 0.8s cubic-bezier(0.165, 0.84, 0.44, 1);
          }

          #ultra-premium-contact .form-container.animate {
            opacity: 1;
            transform: translateX(0);
          }

          #ultra-premium-contact .form-header {
            margin-bottom: 2.5rem;
          }

          #ultra-premium-contact .form-header h2 {
            font-size: 2.5rem;
            font-weight: 800;
            color: var(--text-dark);
            margin: 0 0 10px 0;
            letter-spacing: -0.03em;
          }

          #ultra-premium-contact .form-header p {
            font-size: 1.1rem;
            color: var(--text-muted);
            margin: 0;
          }

          /* Input Grid */
          #ultra-premium-contact .input-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 1.5rem;
            margin-bottom: 1.5rem;
          }

          #ultra-premium-contact .input-group {
            display: flex;
            flex-direction: column;
            gap: 0.5rem;
          }

          #ultra-premium-contact .input-group.full-width {
            grid-column: 1 / -1;
          }

          #ultra-premium-contact label {
            font-size: 0.95rem;
            font-weight: 600;
            color: var(--text-dark);
            margin-left: 0.5rem;
          }

          #ultra-premium-contact input,
          #ultra-premium-contact textarea {
            width: 100%;
            background: var(--input-bg);
            border: 1px solid rgba(0, 0, 0, 0.08);
            border-radius: 16px;
            padding: 1rem 1.2rem;
            font-size: 1rem;
            color: var(--text-dark);
            font-family: inherit;
            transition: all 0.3s ease;
            box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.02);
          }

          #ultra-premium-contact textarea {
            resize: vertical;
            min-height: 120px;
          }

          #ultra-premium-contact input:focus,
          #ultra-premium-contact textarea:focus {
            outline: none;
            border-color: var(--brand-blue);
            box-shadow: 0 0 0 4px rgba(0, 168, 232, 0.15);
            background: #ffffff;
          }

          #ultra-premium-contact input[aria-invalid="true"],
          #ultra-premium-contact textarea[aria-invalid="true"] {
            border-color: #ff3b30;
          }

          #ultra-premium-contact .error {
            color: #ff3b30;
            font-size: 0.85rem;
            margin: 0 0 0 0.5rem;
            font-weight: 500;
          }

          /* Submit Button */
          #ultra-premium-contact .submit-btn {
            width: 100%;
            background: var(--gradient-accent);
            color: #ffffff;
            border: none;
            border-radius: 16px;
            padding: 1.2rem;
            font-size: 1.1rem;
            font-weight: 700;
            cursor: pointer;
            transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
            display: flex;
            justify-content: center;
            align-items: center;
            box-shadow: 0 10px 20px rgba(0, 168, 232, 0.25);
            margin-top: 1rem;
          }

          #ultra-premium-contact .submit-btn:hover:not(:disabled) {
            transform: translateY(-3px);
            box-shadow: 0 15px 30px rgba(236, 28, 116, 0.35);
          }

          #ultra-premium-contact .submit-btn:disabled {
            opacity: 0.7;
            cursor: not-allowed;
          }

          /* Spinner Animation */
          #ultra-premium-contact .spinner {
            width: 24px;
            height: 24px;
            border: 3px solid rgba(255, 255, 255, 0.3);
            border-top: 3px solid #ffffff;
            border-radius: 50%;
            animation: spin 1s linear infinite;
          }

          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }

          /* Success Message */
          #ultra-premium-contact .success-message {
            background: rgba(52, 199, 89, 0.1);
            border: 1px solid #34c759;
            color: #248a3d;
            padding: 1.5rem;
            border-radius: 16px;
            text-align: center;
            font-weight: 600;
            font-size: 1.1rem;
            animation: fadeIn 0.5s ease;
          }

          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
          }

          /* Responsive Tweaks */
          @media (max-width: 992px) {
            #ultra-premium-contact .contact-wrapper {
              grid-template-columns: 1fr;
            }
            #ultra-premium-contact .map-container {
              min-height: 350px;
            }
          }

          @media (max-width: 600px) {
            #ultra-premium-contact { padding: 3rem 1rem; }
            #ultra-premium-contact .form-container { padding: 2.5rem 1.5rem; }
            #ultra-premium-contact .input-grid { grid-template-columns: 1fr; gap: 1rem; }
            #ultra-premium-contact .form-header h2 { font-size: 2rem; }
          }
        `}
      </style>

      <div className="contact-wrapper">
        
        {/* Left Side: Map Container */}
        <div ref={mapRef} className={`map-container ${mapInView ? 'animate' : ''}`}>
          <iframe
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d117460.30624333945!2d77.8095918!3d27.2324826!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x397387922874e291%3A0x218193c1d501f42d!2sMaa%20sadhana%20Nasha%20Mukti%20kendra%2C%20NH-2%2C%20Delhi%20-%20Mathura%20Hwy%2C%20near%20Heera%20lal%20ki%20Pyau%2C%20Sikandra%2C%20Agra%2C%20Uttar%20Pradesh%20282007!5e0!3m2!1sen!2sin!4v1700000000000!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
            title="Maa Sadhana Foundation Location"
          ></iframe>
        </div>

        {/* Right Side: Form Container */}
        <div ref={formRef} className={`form-container ${formInView ? 'animate' : ''}`}>
          <div className="form-header">
            <h2>Confidential Query</h2>
            <p>Reach out to us securely. Our experts are here to help you 24/7.</p>
          </div>

          {submitted ? (
            <div className="success-message">
              Thank you for reaching out! <br/> Your message has been sent successfully. Our team will contact you shortly.
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)}>
              
              <div className="input-grid">
                {/* Full Name */}
                <div className="input-group">
                  <label htmlFor="name">Full Name</label>
                  <input 
                    type="text" 
                    id="name" 
                    placeholder="Enter your name"
                    {...register("name", { required: true })} 
                    aria-invalid={errors.name ? "true" : "false"} 
                  />
                  {errors.name && <p className="error">Name is required</p>}
                </div>

                {/* Email */}
                <div className="input-group">
                  <label htmlFor="email">Email Address</label>
                  <input 
                    type="email" 
                    id="email" 
                    placeholder="Enter your email"
                    {...register("email", { required: true, pattern: /^\S+@\S+$/i })} 
                    aria-invalid={errors.email ? "true" : "false"} 
                  />
                  {errors.email && <p className="error">Valid email is required</p>}
                </div>

                {/* Phone */}
                <div className="input-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input 
                    type="tel" 
                    id="phone" 
                    placeholder="+91 xxxxx xxxxx"
                    {...register("phone", { required: true })} 
                    aria-invalid={errors.phone ? "true" : "false"} 
                  />
                  {errors.phone && <p className="error">Phone is required</p>}
                </div>

                {/* Date */}
                <div className="input-group">
                  <label htmlFor="date">Preferred Date</label>
                  <input 
                    type="date" 
                    id="date" 
                    {...register("date", { required: true })} 
                    aria-invalid={errors.date ? "true" : "false"} 
                  />
                  {errors.date && <p className="error">Date is required</p>}
                </div>

                {/* Message */}
                <div className="input-group full-width">
                  <label htmlFor="message">How can we help you?</label>
                  <textarea 
                    id="message" 
                    placeholder="Write your message here..."
                    {...register("message", { required: true })} 
                    aria-invalid={errors.message ? "true" : "false"}
                  ></textarea>
                  {errors.message && <p className="error">Message cannot be empty</p>}
                </div>
              </div>

              <button className="submit-btn" type="submit" disabled={isSubmitting}>
                {isSubmitting ? <span className="spinner"></span> : 'Send Secure Message'}
              </button>

            </form>
          )}
        </div>

      </div>
    </div>
  );
}

export default ContactForm;